import {
	ContactOwnerCriteria,
	ETextingFeatureProvider,
	HandwrittenCardProvider,
	IMeetingDuration,
	UpcomingKeyDateDisplayScope,
} from '../../../../../extViewmodels';
import { IConfirmationDialogOption } from '../../../../../web/components/ConfirmationDialog';
import { ISelectOption } from '../../../../../web/components/DeprecatedSelect';

export enum UserRole {
	LimitedUser = 'limitedUser',
	User = 'user',
	Admin = 'admin',
	SuperAdmin = 'superAdmin',
}

export const UserOptions: ISelectOption<UserRole>[] = [
	{
		dataContext: UserRole.User,
		id: 'user-option-user',
		text: 'User',
	},
	{
		dataContext: UserRole.LimitedUser,
		id: 'user-option-limited-user',
		text: 'Limited User',
	},
];

export const RoleForOpportunitiesOptions: ISelectOption<UserRole>[] = [
	{
		dataContext: UserRole.User,
		id: 'user-option-user',
		text: 'User',
	},
	{
		dataContext: UserRole.Admin,
		id: 'user-option-admin',
		text: 'Admin',
	},
	{
		dataContext: UserRole.SuperAdmin,
		id: 'user-option-super-admin',
		text: 'Super Admin',
	},
];

export enum Privacy {
	Admin = 'admin',
	All = 'all',
}

export const PrivacyOptions: ISelectOption<Privacy>[] = [
	{
		dataContext: Privacy.Admin,
		id: 'privacy-option-private',
		text: 'Private',
	},
	{
		dataContext: Privacy.All,
		id: 'privacy-option-public',
		text: 'Public',
	},
];

export const TextingProviderOptions: ISelectOption<ETextingFeatureProvider>[] = [
	{
		dataContext: ETextingFeatureProvider.Twilio,
		id: 'texting-provider-option-twilio',
		text: ETextingFeatureProvider.Twilio,
	},
	{
		dataContext: ETextingFeatureProvider.Bandwidth,
		id: 'texting-provider-option-bandwidth',
		text: ETextingFeatureProvider.Bandwidth,
	},
];

export const HandwrittenCardProviderOptions: ISelectOption<HandwrittenCardProvider>[] = [
	{
		dataContext: HandwrittenCardProvider.Cardly,
		id: 'handwrittencard-provider-option-cardly',
		text: 'Cardly',
	},
];

export enum EnhancementType {
	CompaniesOnly = 'companiesOnly',
	Off = 'off',
}

export const EnhancementOptions: ISelectOption<EnhancementType>[] = [
	{
		dataContext: EnhancementType.CompaniesOnly,
		id: 'enhancement-option-companies-only',
		text: 'Companies',
	},
	{
		dataContext: EnhancementType.Off,
		id: 'enhancement-option-off',
		text: 'Off',
	},
];

/** Mirrors Levitate.Models.WebsiteTiers -- the API rejects any other value. */
export enum WebsiteTier {
	Essential = 'Essential',
	Preferred = 'Preferred',
	Prestige = 'Prestige',
}

export const WebsiteTierOptions: ISelectOption<WebsiteTier>[] = [
	{
		dataContext: WebsiteTier.Essential,
		id: 'website-tier-option-essential',
		text: 'Essential',
	},
	{
		dataContext: WebsiteTier.Preferred,
		id: 'website-tier-option-preferred',
		text: 'Preferred',
	},
	{
		dataContext: WebsiteTier.Prestige,
		id: 'website-tier-option-prestige',
		text: 'Prestige',
	},
];

export const RenewalMonthsOptions: ISelectOption<number>[] = [
	{
		dataContext: 1,
		id: 'renewal-months-option-1',
		text: '1 Month',
	},
	{
		dataContext: 2,
		id: 'renewal-months-option-2',
		text: '2 Months',
	},
	{
		dataContext: 3,
		id: 'renewal-months-option-3',
		text: '3 Months',
	},
	{
		dataContext: 6,
		id: 'renewal-months-option-6',
		text: '6 Months',
	},
	{
		dataContext: 12,
		id: 'renewal-months-option-12',
		text: '12 Months',
	},
];

export const SendOnBehalfWaitTimeOptions: ISelectOption<IMeetingDuration>[] = [
	{
		dataContext: { days: 2, hours: 0, minutes: 0, seconds: 0 },
		id: 'send-on-behalf-wait-time-option-2-days',
		text: '2 Days',
	},
	{
		dataContext: { days: 1, hours: 0, minutes: 0, seconds: 0 },
		id: 'send-on-behalf-wait-time-option-1-day',
		text: '1 Day',
	},
	{
		dataContext: { days: 0, hours: 1, minutes: 0, seconds: 0 },
		id: 'send-on-behalf-wait-time-option-1-hour',
		text: '1 Hour',
	},
];

export const ComplianceWaitTimeOptions: ISelectOption<IMeetingDuration>[] = [
	{
		dataContext: { days: 2, hours: 0, minutes: 0, seconds: 0 },
		id: 'compliance-wait-time-option-2-days',
		text: '2 Days',
	},
	{
		dataContext: { days: 1, hours: 0, minutes: 0, seconds: 0 },
		id: 'compliance-wait-time-option-1-day',
		text: '1 Day',
	},
	{
		dataContext: { days: 0, hours: 1, minutes: 0, seconds: 0 },
		id: 'compliance-wait-time-option-1-hour',
		text: '1 Hour',
	},
];

enum EDaysOptions {
	Thirty = 30,
	Sixty = 60,
	Ninety = 90,
	OneTwenty = 120,
	OneEighty = 180,
	TwoSeventy = 270,
	ThreeThirty = 330,
	ThreeSixtyFive = 365,
}

export const RenewalDaysOptions: ISelectOption<number>[] = [
	createSelectOption(EDaysOptions.Thirty, 'renewal-days-option'),
	createSelectOption(EDaysOptions.Sixty, 'renewal-days-option'),
	createSelectOption(EDaysOptions.Ninety, 'renewal-days-option'),
	createSelectOption(EDaysOptions.OneTwenty, 'renewal-days-option'),
];

export const CustomCardDaysOptions: ISelectOption<number>[] = [
	createSelectOption(EDaysOptions.Thirty, 'custom-card-days-option'),
	createSelectOption(EDaysOptions.Sixty, 'custom-card-days-option'),
	createSelectOption(EDaysOptions.Ninety, 'custom-card-days-option'),
	createSelectOption(EDaysOptions.OneTwenty, 'custom-card-days-option'),
];

export const ContactOwnerCriteriaOptions: ISelectOption<ContactOwnerCriteria>[] = [
	{
		// Deliberately not a behavioral description: Default resolves per reminder type at read time (owner-only for
		// renewals and financial reviews, owners and their connections for most others), so no single label is accurate.
		dataContext: ContactOwnerCriteria.Default,
		id: 'contact-owner-criteria-option-default',
		text: 'Default (varies by reminder type)',
	},
	{
		dataContext: ContactOwnerCriteria.ForUserOnly,
		id: 'contact-owner-criteria-option-for-users-only',
		text: 'For users only',
	},
	{
		dataContext: ContactOwnerCriteria.OnBehalfOfContactOwners,
		id: 'contact-owner-criteria-option-contact-owners',
		text: 'On behalf of contact owners',
	},
];

const DASH_DAYS = '-days';

export const Turning65Options: ISelectOption<number>[] = [
	createSelectOption(EDaysOptions.Sixty, 'turning-65-option', DASH_DAYS),
	createSelectOption(EDaysOptions.Ninety, 'turning-65-option', DASH_DAYS),
	createSelectOption(EDaysOptions.OneTwenty, 'turning-65-option', DASH_DAYS),
	createSelectOption(EDaysOptions.OneEighty, 'turning-65-option', DASH_DAYS),
	createSelectOption(EDaysOptions.TwoSeventy, 'turning-65-option', DASH_DAYS),
	createSelectOption(EDaysOptions.ThreeThirty, 'turning-65-option', DASH_DAYS),
	createSelectOption(EDaysOptions.ThreeSixtyFive, 'turning-65-option', DASH_DAYS),
];

export const TurningXXOptions: ISelectOption<number>[] = [
	createSelectOption(EDaysOptions.Sixty, 'turning-xx-option', DASH_DAYS),
	createSelectOption(EDaysOptions.Ninety, 'turning-xx-option', DASH_DAYS),
	createSelectOption(EDaysOptions.OneTwenty, 'turning-xx-option', DASH_DAYS),
	createSelectOption(EDaysOptions.OneEighty, 'turning-xx-option', DASH_DAYS),
	createSelectOption(EDaysOptions.TwoSeventy, 'turning-xx-option', DASH_DAYS),
	createSelectOption(EDaysOptions.ThreeThirty, 'turning-xx-option', DASH_DAYS),
	createSelectOption(EDaysOptions.ThreeSixtyFive, 'turning-xx-option', DASH_DAYS),
];

export const Turning72Options: ISelectOption<number>[] = [
	createSelectOption(EDaysOptions.Sixty, 'turning-72-option', DASH_DAYS),
	createSelectOption(EDaysOptions.Ninety, 'turning-72-option', DASH_DAYS),
	createSelectOption(EDaysOptions.OneTwenty, 'turning-72-option', DASH_DAYS),
	createSelectOption(EDaysOptions.OneEighty, 'turning-72-option', DASH_DAYS),
	createSelectOption(EDaysOptions.TwoSeventy, 'turning-72-option', DASH_DAYS),
	createSelectOption(EDaysOptions.ThreeThirty, 'turning-72-option', DASH_DAYS),
];

export const Turning73Options: ISelectOption<number>[] = [
	createSelectOption(EDaysOptions.Sixty, 'turning-73-option', DASH_DAYS),
	createSelectOption(EDaysOptions.Ninety, 'turning-73-option', DASH_DAYS),
	createSelectOption(EDaysOptions.OneTwenty, 'turning-73-option', DASH_DAYS),
	createSelectOption(EDaysOptions.OneEighty, 'turning-73-option', DASH_DAYS),
	createSelectOption(EDaysOptions.TwoSeventy, 'turning-73-option', DASH_DAYS),
	createSelectOption(EDaysOptions.ThreeThirty, 'turning-73-option', DASH_DAYS),
];

export const TurningXX3Options: ISelectOption<number>[] = [
	createSelectOption(EDaysOptions.Sixty, 'turning-xx3-option', DASH_DAYS),
	createSelectOption(EDaysOptions.Ninety, 'turning-xx3-option', DASH_DAYS),
	createSelectOption(EDaysOptions.OneTwenty, 'turning-xx3-option', DASH_DAYS),
	createSelectOption(EDaysOptions.OneEighty, 'turning-xx3-option', DASH_DAYS),
	createSelectOption(EDaysOptions.TwoSeventy, 'turning-xx3-option', DASH_DAYS),
	createSelectOption(EDaysOptions.ThreeThirty, 'turning-xx3-option', DASH_DAYS),
	createSelectOption(EDaysOptions.ThreeSixtyFive, 'turning-xx3-option', DASH_DAYS),
];

export const TurningXX4Options: ISelectOption<number>[] = [
	createSelectOption(EDaysOptions.Sixty, 'turning-xx4-option', DASH_DAYS),
	createSelectOption(EDaysOptions.Ninety, 'turning-xx4-option', DASH_DAYS),
	createSelectOption(EDaysOptions.OneTwenty, 'turning-xx4-option', DASH_DAYS),
	createSelectOption(EDaysOptions.OneEighty, 'turning-xx4-option', DASH_DAYS),
	createSelectOption(EDaysOptions.TwoSeventy, 'turning-xx4-option', DASH_DAYS),
	createSelectOption(EDaysOptions.ThreeThirty, 'turning-xx4-option', DASH_DAYS),
	createSelectOption(EDaysOptions.ThreeSixtyFive, 'turning-xx4-option', DASH_DAYS),
];

export const TurningXX5Options: ISelectOption<number>[] = [
	createSelectOption(EDaysOptions.Sixty, 'turning-xx5-option', DASH_DAYS),
	createSelectOption(EDaysOptions.Ninety, 'turning-xx5-option', DASH_DAYS),
	createSelectOption(EDaysOptions.OneTwenty, 'turning-xx5-option', DASH_DAYS),
	createSelectOption(EDaysOptions.OneEighty, 'turning-xx5-option', DASH_DAYS),
	createSelectOption(EDaysOptions.TwoSeventy, 'turning-xx5-option', DASH_DAYS),
	createSelectOption(EDaysOptions.ThreeThirty, 'turning-xx5-option', DASH_DAYS),
	createSelectOption(EDaysOptions.ThreeSixtyFive, 'turning-xx5-option', DASH_DAYS),
];

function createSelectOption(num: number, id: string, optionalText?: string) {
	return {
		dataContext: num,
		id: `${id}-${num}${optionalText ?? ''}}`,
		text:
			num === 365
				? `1 year`
				: num === 330
					? '11 months'
					: num === 270
						? '9 months'
						: num === 180
							? '6 months'
							: `${num} Days`,
	};
}

const options = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20].map(i => {
	const v = i * 1000;
	return {
		dataContext: v,
		id: '',
		text: `${v}`,
	};
});

export const valueAsContextAndTextOption = (id: string, value: number): ISelectOption<number> => ({
	dataContext: value,
	id,
	text: value.toString(),
});

export const MaximumGroupAutomationContacts: ISelectOption<number>[] = [
	{
		dataContext: 250,
		id: 'max-group-automation-contacts-default',
		text: 'Default',
	},
	...options.map(o => {
		o.id = `max-group-automation-contacts-${o.dataContext}`;
		return o;
	}),
];
export const MaximumGroupSendContacts: ISelectOption<number>[] = [
	{ dataContext: 250, id: 'max-group-send-contacts-default', text: 'Default' },
	...options.map(o => {
		o.id = `max-group-send-contacts-${o.dataContext}`;
		return o;
	}),
];
export const MaximumHTMLNewsletterContacts: ISelectOption<number>[] = [
	{ dataContext: 5000, id: 'max-html-contacts-default', text: 'Default' },
	...options.map(o => {
		o.id = `max-html-contacts-${o.dataContext}`;
		return o;
	}),
];

/*
 * This purposefully excludes UpcomingKeyDateScopes.All.
 * It was added on the platform side (and in models) for parity, but we do not support using it at this time.
 */
export const UpcomingKeyDateDisplayScopes: ISelectOption<UpcomingKeyDateDisplayScope>[] = [
	{
		dataContext: UpcomingKeyDateDisplayScope.Connections,
		id: 'upcoming-key-date-display-scopes-option-connections',
		text: 'Connections',
	},
	{
		dataContext: UpcomingKeyDateDisplayScope.OwnersOnly,
		id: 'upcoming-key-date-display-scopes-option-owner-only',
		text: 'Owner Only',
	},
];

// Default Email Style Font Options - matching TinyMCE configuration
export const DefaultEmailFontFaceOptions: ISelectOption<string>[] = [
	{
		dataContext: 'sans-serif',
		id: 'default-email-font-face-sans-serif',
		text: 'Sans Serif',
	},
	{
		dataContext: 'serif',
		id: 'default-email-font-face-serif',
		text: 'Serif',
	},
	{
		dataContext: 'aptos,calibri,arial,helvetica,sans-serif',
		id: 'default-email-font-face-aptos',
		text: 'Aptos',
	},
	{
		dataContext: 'arial,helvetica,sans-serif',
		id: 'default-email-font-face-arial',
		text: 'Arial',
	},
	{
		dataContext: 'arial black,avant garde,arial,helvetica,sans-serif',
		id: 'default-email-font-face-arial-black',
		text: 'Arial Black',
	},
	{
		dataContext: 'book antiqua,palatino,georgia,times new roman,serif',
		id: 'default-email-font-face-book-antiqua',
		text: 'Book Antiqua',
	},
	{
		dataContext: 'calibri,arial,helvetica,sans-serif',
		id: 'default-email-font-face-calibri',
		text: 'Calibri',
	},
	{
		dataContext: 'century gothic,gothic,arial,helvetica,sans-serif',
		id: 'default-email-font-face-century-gothic',
		text: 'Century Gothic',
	},
	{
		dataContext: 'comic sans ms,trebuchet ms,arial,helvetica,sans-serif',
		id: 'default-email-font-face-comic-sans',
		text: 'Comic Sans MS',
	},
	{
		dataContext: 'courier new,courier,consolas,monaco,monospace',
		id: 'default-email-font-face-courier-new',
		text: 'Courier New',
	},
	{
		dataContext: 'georgia,times new roman,times,serif',
		id: 'default-email-font-face-georgia',
		text: 'Georgia',
	},
	{
		dataContext: 'helvetica,arial,sans-serif',
		id: 'default-email-font-face-helvetica',
		text: 'Helvetica',
	},
	{
		dataContext: 'tahoma,arial,helvetica,sans-serif',
		id: 'default-email-font-face-tahoma',
		text: 'Tahoma',
	},
	{
		dataContext: 'times new roman,times,georgia,serif',
		id: 'default-email-font-face-times-new-roman',
		text: 'Times New Roman',
	},
	{
		dataContext: 'trebuchet ms,arial,helvetica,sans-serif',
		id: 'default-email-font-face-trebuchet',
		text: 'Trebuchet MS',
	},
	{
		dataContext: 'verdana,arial,helvetica,sans-serif',
		id: 'default-email-font-face-verdana',
		text: 'Verdana',
	},
];

export const DefaultEmailFontSizeOptions: ISelectOption<string>[] = [
	{
		dataContext: '10px',
		id: 'default-email-font-size-10',
		text: '10px',
	},
	{
		dataContext: '11px',
		id: 'default-email-font-size-11',
		text: '11px',
	},
	{
		dataContext: '12px',
		id: 'default-email-font-size-12',
		text: '12px',
	},
	{
		dataContext: '14px',
		id: 'default-email-font-size-14',
		text: '14px',
	},
	{
		dataContext: '16px',
		id: 'default-email-font-size-16',
		text: '16px',
	},
	{
		dataContext: '18px',
		id: 'default-email-font-size-18',
		text: '18px',
	},
	{
		dataContext: '24px',
		id: 'default-email-font-size-24',
		text: '24px',
	},
	{
		dataContext: '36px',
		id: 'default-email-font-size-36',
		text: '36px',
	},
	{
		dataContext: '48px',
		id: 'default-email-font-size-48',
		text: '48px',
	},
];

export const DeleteKeyFactsConfirmationOptions: IConfirmationDialogOption[] = [
	{
		isDestructive: true,
		title: 'Delete',
	},
	{
		isCancel: true,
		title: 'Cancel',
	},
];

export const ArchiveAllDonationsConfirmationOptions: IConfirmationDialogOption[] = [
	{
		isDestructive: true,
		title: 'Archive',
	},
	{
		isCancel: true,
		title: 'Cancel',
	},
];
